import React from 'react';
import ToggleOff from '@mui/icons-material/ToggleOffOutlined';
import ToggleOn from '@mui/icons-material/ToggleOn';
import Select from 'react-select';
import ColorPicker from '../../../Components/ColorPicker';
import LabelColorSlider from '../../../Components/LabelColorSlider';

const toggleStyle = { color: 'var(--accent)', width: '48px', height: '40px', cursor: 'pointer' };

const SliderNumberSettings = ({
  edit,
  setEdit,
  t,
  selectedDatastream,
  directionLabels,
  getDsMinMax,
  themeColorKey,
  themeColorValue,
}) => {
  if (!(edit.dataId > 0 && (edit.type === 'slider' || edit.type === 'number'))) {
    return null;
  }

  const sliderDirectionOptions = [
    { label: directionLabels.leftToRightShort || 'Left to Right (ltr)', value: 'ltr' },
    { label: directionLabels.rightToLeftShort || 'Right to Left (rtl)', value: 'rtl' },
  ];

  return (
    <>
      <div className='form-item'>
        <label className='form-lbl' style={{ color: 'var(--header-color)' }}>
          {t.settingsLabels?.buttonBgColor || 'Buttons Background Color'}
        </label>
        <ColorPicker
          id="buttonBgColor"
          color={themeColorValue(
            edit.props,
            'buttonBgColor'
          )}
          setColor={(c) => setEdit(prev => ({
            ...prev,
            props: { ...prev.props, [themeColorKey('buttonBgColor')]: c }
          }))}
        />
      </div>

      <div className='form-item'>
        <label className='form-lbl' style={{ color: 'var(--header-color)' }}>
          {t.settingsLabels?.buttonTextColor || 'Buttons Text Color (+ / -)'}
        </label>
        <ColorPicker
          id="buttonTextColor"
          color={themeColorValue(
            edit.props,
            'color',
            selectedDatastream?.color || '#C52184'
          )}
          setColor={(c) => setEdit(prev => ({
            ...prev,
            props: { ...prev.props, [themeColorKey('color')]: c }
          }))}
        />
      </div>

      {edit.type === 'number' ? (
        <div className='form-item'>
          <label className='form-lbl' style={{ color: 'var(--header-color)' }}>
            {t.settingsLabels?.buttonHoverBgColor || 'Buttons Hover Background Color'}
          </label>
          <ColorPicker
            id="buttonHoverBgColor"
            color={themeColorValue(
              edit.props,
              'buttonHoverBgColor',
              themeColorValue(edit.props, 'buttonBgColor')
            )}
            setColor={(c) => setEdit(prev => ({
              ...prev,
              props: { ...prev.props, [themeColorKey('buttonHoverBgColor')]: c }
            }))}
          />
        </div>
      ) : null}

      <div className='form-item'>
        <label className='form-lbl' style={{ color: 'var(--header-color)' }}>
          {t.settingsLabels?.changeColorBasedOnValue || 'Change Color Based On Value'}
        </label>
        {edit.props.changeColorBasedOnValue ? (
          <ToggleOn
            style={toggleStyle}
            onClick={() => setEdit(prev => ({
              ...prev,
              props: { ...prev.props, changeColorBasedOnValue: false }
            }))}
          />
        ) : (
          <ToggleOff
            style={toggleStyle}
            onClick={() => setEdit(prev => ({
              ...prev,
              props: { ...prev.props, changeColorBasedOnValue: true }
            }))}
          />
        )}
      </div>

      {edit.props.changeColorBasedOnValue ? (
        <>
          <div className='form-item'>
            <label className='form-lbl' style={{ color: 'var(--header-color)' }}>
              {t.settingsLabels?.colorGrading || 'Smooth Gradient Transition'}
            </label>
            {edit.props.colorGrading ? (
              <ToggleOn
                style={toggleStyle}
                onClick={() => setEdit(prev => ({
                  ...prev,
                  props: { ...prev.props, colorGrading: false }
                }))}
              />
            ) : (
              <ToggleOff
                style={toggleStyle}
                onClick={() => setEdit(prev => ({
                  ...prev,
                  props: { ...prev.props, colorGrading: true }
                }))}
              />
            )}
          </div>

          <LabelColorSlider
            minValue={getDsMinMax(selectedDatastream).min ?? edit.props.min}
            maxValue={getDsMinMax(selectedDatastream).max ?? edit.props.max}
            stops={themeColorValue(edit.props, 'colors', [])}
            colorGrading={Boolean(edit.props.colorGrading)}
            setStops={(updated) => setEdit(prev => ({
              ...prev,
              props: { ...prev.props, [themeColorKey('colors')]: updated }
            }))}
          />
        </>
      ) : (
        <div className='form-item'>
          <label className='form-lbl' style={{ color: 'var(--header-color)' }}>
            {t.settingsLabels?.valueColor || 'Widget Value Color'}
          </label>
          <ColorPicker
            id="valueColor"
            color={themeColorValue(
              edit.props,
              'valueColor',
              themeColorValue(
                edit.props,
                'color',
                selectedDatastream?.color || '#C52184'
              )
            )}
            setColor={(c) => setEdit(prev => ({
              ...prev,
              props: { ...prev.props, [themeColorKey('valueColor')]: c }
            }))}
          />
        </div>
      )}

      {edit.type === 'number' ? (
        <div className='form-item'>
          <label className='form-lbl' style={{ color: 'var(--header-color)' }}>
            {t.settingsLabels?.valueHoverColor || 'Widget Value Hover Color'}
          </label>
          <ColorPicker
            id="valueHoverColor"
            color={themeColorValue(
              edit.props,
              'valueHoverColor',
              themeColorValue(
                edit.props,
                'valueColor',
                themeColorValue(
                  edit.props,
                  'color',
                  selectedDatastream?.color || '#C52184'
                )
              )
            )}
            setColor={(c) => setEdit(prev => ({
              ...prev,
              props: { ...prev.props, [themeColorKey('valueHoverColor')]: c }
            }))}
          />
        </div>
      ) : null}

      {edit.type === 'slider' ? (
        <div className='form-item'>
          <label className='form-lbl' style={{ color: 'var(--header-color)' }}>{t.sliderDirection || 'Direction'}</label>
          <Select
            classNamePrefix="react-select"
            value={sliderDirectionOptions.find(o => o.value === edit.props.direction)}
            options={sliderDirectionOptions}
            onChange={selectedOption => setEdit({
              ...edit,
              props: { ...edit.props, direction: selectedOption ? selectedOption.value : '' }
            })}
            isClearable={true}
          />
        </div>
      ) : null}
    </>
  );
};

export default SliderNumberSettings;
